export default {
  'mediaCategories.title': 'Manage Media Categories',
  'mediaCategories.form.color': 'Color',
};
